import {
    CaseReportsDocument,
    CaseReportsQuery,
    CaseReportsQueryVariables,
} from '@graphql/generated/graphql';

import { useQuery, useReactiveVar } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import { authVar } from '@boot/reactiveVariables';

interface UseCaseReportStatisticsProps
    extends QueryHookOptions<CaseReportsQuery, CaseReportsQueryVariables> {}
export const useCaseReportStatistics = (
    props?: UseCaseReportStatisticsProps,
) => {
    const isLoggedIn = useReactiveVar(authVar).isLoggedIn;
    const isGuest = useReactiveVar(authVar).isGuest;

    return useQuery(CaseReportsDocument, {
        skip: isGuest || !isLoggedIn,
        ...props,
    });
};
